

// import React, { useEffect, useState, useCallback } from "react";
// import { useDispatch, useSelector } from "react-redux";
// import { useNavigate, useParams } from "react-router-dom";
// import { GetCategoryApi } from "../redux/actions/teams/members/GetCategoryAction";
// import { GetQuizDetailApi } from "../redux/actions/teams/members/GetQuizDetailsActions";
// import { UpdateQuiz } from "../redux/actions/teams/members/UpdateQuizAction";
// import { PulseLoader } from "react-spinners";

// const EditQuiz = () => {
//   const { id } = useParams();
//   const navigate = useNavigate();
//   const dispatch = useDispatch();

//   const [quizName, setQuizName] = useState("");
//   const [quizCategory, setQuizCategory] = useState("");
//   const [description, setDescription] = useState("");
//   const [tips, setTips] = useState("");
//   const [nhsGuidance, setNhsGuidance] = useState([{ text: "", url: "" }]);
//   const [marks, setMarks] = useState(50);
//   const [totalTime, setTotalTime] = useState(60);
//   const [statusss, setStatus] = useState(1);
//   const [quizImage, setQuizImage] = useState(null);
//   const [quizImagePreview, setQuizImagePreview] = useState(null);

//   const [questions, setQuestions] = useState([]);
//   const [errors, setErrors] = useState({ 
//     quizName: "", 
//     quizCategory: "", 
//     questions: "" 
//   });
  
//   const [questionErrors, setQuestionErrors] = useState([]);

//   // Redux states
//   const { response: categoryListResponse, loading: categoryListLoading } = useSelector(
//     (state) => state.categoryList
//   );
//   const { response: quizDetailsResponse, loading: quizLoading, error: quizError } = useSelector(
//     (state) => state.QuizDetails
//   );
//   const { loading: updateLoading, error: updateError } = useSelector((state) => state.updateQuiz);

//   // Fetch categories
//   const fetchCategories = useCallback(() => {
//     dispatch(GetCategoryApi());
//   }, [dispatch]);

//   // Fetch quiz details
//   useEffect(() => {
//     if (id) {
//       dispatch(GetQuizDetailApi(id));
//     }
//   }, [dispatch, id]);

//   // NHS Guidance handlers
//   const addNhsGuidance = () => {
//     setNhsGuidance([...nhsGuidance, { text: "", url: "" }]);
//   };

//   const updateNhsGuidance = (index, field, value) => {
//     const updated = [...nhsGuidance];
//     updated[index][field] = value;
//     setNhsGuidance(updated);
//   };

//   const removeNhsGuidance = (index) => {
//     if (nhsGuidance.length > 1) {
//       const updated = nhsGuidance.filter((_, i) => i !== index);
//       setNhsGuidance(updated);
//     }
//   };

//   // Load quiz details
//   useEffect(() => {
//     if (quizDetailsResponse?.status && quizDetailsResponse.data) {
//       const d = quizDetailsResponse.data;
//       setQuizName(d.quiz_name);
//       setQuizCategory(d.quiz_category);
//       setTips(d.tips ? d.tips.join("\n") : "");
//       setDescription(d.description);
//       setMarks(d.total_marks);
//       setTotalTime(d.total_time);
//       setStatus(d.statusss);
      
//       // Load questions
//       const loadedQuestions = (d.questions || []).map(q => ({
//         ...q,
//         options: { ...q.options },
//         status: q.status || 1,
//         correct_answer: q.correct_answer || 'a'
//       }));
      
//       setQuestions(loadedQuestions);
//       setQuestionErrors(Array(loadedQuestions.length).fill({}));


// if (d.nhs_guidance && Array.isArray(d.nhs_guidance)) {
//   if (d.nhs_guidance.length > 0 && typeof d.nhs_guidance[0] === 'object') {
//     // Create deep copy to make objects mutable
//     setNhsGuidance(d.nhs_guidance.map(item => ({ 
//       text: item.text, 
//       url: item.url 
//     })));
//   } else {
//     // Convert legacy string format to object format
//     setNhsGuidance(d.nhs_guidance.map(text => ({ 
//       text: text, 
//       url: `https://www.nhs.uk/search/?q=${encodeURIComponent(text)}` 
//     })));
//   }
// } else {
//   setNhsGuidance([{ text: "", url: "" }]);
// }

//       if (d.quiz_image) {
//         setQuizImagePreview(`${process.env.REACT_APP_BACKEND_PRODUCTION_URL}/uploads/${d.quiz_image}`);
//       }
//     }
//   }, [quizDetailsResponse]);

//   useEffect(() => {
//     fetchCategories();
//   }, [fetchCategories]);

//   // Add new question
//   const addQuestion = () => {
//     setQuestions([
//       ...questions,
//       { 
//         question: "", 
//         options: { a: "", b: "", c: "", d: "" }, 
//         correct_answer: "", 
//         explanation: "" 
//       },
//     ]);
//     setQuestionErrors([...questionErrors, {}]);
//   };

//   // ... (other handlers remain the same - handleQuestionChange, handleOptionChange, etc.)

//   const handleQuestionChange = (index, field, value) => {
//     const updated = [...questions];
//     updated[index][field] = value;
//     setQuestions(updated);

//     // Clear error when field is filled
//     if (value.trim() && field === "question") {
//       const updatedErrors = [...questionErrors];
//       delete updatedErrors[index]?.question;
//       setQuestionErrors(updatedErrors);
//     }
//     if (value && field === "correct_answer") {
//       const updatedErrors = [...questionErrors];
//       delete updatedErrors[index]?.correct_answer;
//       setQuestionErrors(updatedErrors);
//     }
//   };

//   const handleOptionChange = (index, optKey, value) => {
//     const updated = [...questions];
//     updated[index].options[optKey] = value;
//     setQuestions(updated);

//     // Clear error when option is filled
//     if (value.trim()) {
//       const updatedErrors = [...questionErrors];
//       if (updatedErrors[index]?.options?.[optKey]) {
//         delete updatedErrors[index].options[optKey];
//         setQuestionErrors(updatedErrors);
//       }
//     }
//   };

//   const handleImageChange = (e) => {
//     const file = e.target.files[0];
//     if (file) {
//       setQuizImage(file);
//       setQuizImagePreview(URL.createObjectURL(file));
//     }
//   };

//   // ... (validation functions remain the same)

//   const validateQuestion = (question, index) => {
//     const errors = {};
    
//     if (!question.question.trim()) {
//       errors.question = "Question is required";
//     }
    
//     if (!question.correct_answer) {
//       errors.correct_answer = "Correct answer is required";
//     }
    
//     const optionErrors = {};
//     let hasEmptyOption = false;
    
//     Object.keys(question.options).forEach(opt => {
//       if (!question.options[opt].trim()) {
//         optionErrors[opt] = `Option ${opt.toUpperCase()} is required`;
//         hasEmptyOption = true;
//       }
//     });
    
//     if (hasEmptyOption) {
//       errors.options = optionErrors;
//     }
    
//     return errors;
//   };

//   const validateForm = () => {
//     let valid = true;
//     const newErrors = { quizName: "", quizCategory: "", questions: "" };
//     const newQuestionErrors = [];

//     if (!quizName.trim()) {
//       newErrors.quizName = "Quiz name is required";
//       valid = false;
//     }
//     if (!quizCategory) {
//       newErrors.quizCategory = "Quiz category is required";
//       valid = false;
//     }

//     if (!questions.length) {
//       newErrors.questions = "At least one question is required";
//       valid = false;
//     } else {
//       let hasQuestionError = false;
      
//       questions.forEach((question, index) => {
//         const questionError = validateQuestion(question, index);
//         newQuestionErrors[index] = questionError;
        
//         if (Object.keys(questionError).length > 0) {
//           hasQuestionError = true;
//         }
//       });
      
//       if (hasQuestionError) {
//         newErrors.questions = "Please fix all question errors before submitting";
//         valid = false;
//       }
//     }

//     setErrors(newErrors);
//     setQuestionErrors(newQuestionErrors);
//     return valid;
//   };

//   // Submit
//   const handleSubmit = (e) => {
//     e.preventDefault();
//     if (!validateForm()) return;

//     const formData = new FormData();
//     formData.append("quiz_category", quizCategory);
//     formData.append("quiz_name", quizName);
//     formData.append("description", description);
//     formData.append("total_marks", marks);
//     formData.append("total_questions", questions.length);
//     formData.append("total_time", totalTime);
//     formData.append("statusss", statusss);
//     formData.append("questions", JSON.stringify(questions));
    
//     // Filter out empty NHS guidance entries
//     const validNhsGuidance = nhsGuidance.filter(item => 
//       item.text.trim() !== "" && item.url.trim() !== ""
//     );
//     formData.append("nhs_guidance", JSON.stringify(validNhsGuidance));
    
//     const tipsArray = tips.split("\n").filter((t) => t.trim() !== "");
//     formData.append("tips", JSON.stringify(tipsArray));

//     if (quizImage) {
//       formData.append("quiz_image", quizImage);
//     }

//     dispatch(UpdateQuiz(id, formData))
//       .then(() => navigate("/dashboard/quiz-management"))
//       .catch((err) => console.error("Failed to update quiz:", err));
//   };

//   if (quizLoading) return <div className="text-center p-5">Loading quiz...</div>;
//   if (quizError) return <div className="text-center p-5 text-danger">Error loading quiz</div>;

//   return (
//     <div className="content-wrapper" style={{ backgroundColor: "#f5f5f5" }}>
//       <section className="main-section">
//         <div className="container py-5">
//           <div className="row justify-content-center">
//             <div className="col-12 col-md-10 col-lg-8">
//               <form onSubmit={handleSubmit} className="p-3 shadow rounded bg-white">
//                 <h3 className="text-center mb-3">Edit Quiz</h3>

//                 {updateLoading && (
//                   <div className="text-center mb-3">
//                     <PulseLoader color="#36d7b7" size={10} />
//                   </div>
//                 )}
//                 {updateError && (
//                   <div className="alert alert-danger mb-3">
//                     {updateError.data || "Failed to update quiz"}
//                   </div>
//                 )}

//                 {/* Status */}
//                 <div className="d-flex justify-content-end mb-3">
//                   <label className="me-2">Status</label>
//                   <input
//                     type="checkbox"
//                     checked={statusss === 1}
//                     onChange={(e) => setStatus(e.target.checked ? 1 : 0)}
//                   />
//                 </div>

//                 {/* Image */}
//                 <div className="col-12 mb-3">
//                   <h6>Quiz Image</h6>
//                   <input type="file" className="form-control" accept="image/*" onChange={handleImageChange} />
//                   {quizImagePreview && (
//                     <div className="mt-2 text-center">
//                       <img src={quizImagePreview} alt="Preview" style={{ maxWidth: "150px", borderRadius: "6px" }} />
//                     </div>
//                   )}
//                 </div>

//                 {/* Info */}
//                 <div className="row g-3 mb-3">
//                   <div className="col-12 col-md-6">
//                     <h6>Quiz Name</h6>
//                     <input 
//                       type="text" 
//                       className="form-control" 
//                       value={quizName} 
//                       onChange={(e) => setQuizName(e.target.value)} 
//                     />
//                     {errors.quizName && <small className="text-danger">{errors.quizName}</small>}
//                   </div>
//                   <div className="col-12 col-md-6">
//                     <h6>Quiz Category</h6>
//                     <select 
//                       className="form-select" 
//                       value={quizCategory} 
//                       onChange={(e) => setQuizCategory(e.target.value)}
//                     >
//                       <option value="">Select Category</option>
//                       {categoryListResponse?.data?.map((c) => (
//                         <option key={c._id} value={c._id}>
//                           {c.name}
//                         </option>
//                       ))}
//                     </select>
//                     {errors.quizCategory && <small className="text-danger">{errors.quizCategory}</small>}
//                   </div>
//                   <div className="col-12">
//                     <h6>Description</h6>
//                     <textarea 
//                       className="form-control" 
//                       value={description} 
//                       onChange={(e) => setDescription(e.target.value)} 
//                     />
//                   </div>
//                   <div className="col-12">
//                     <h6>Tips & Guidelines</h6>
//                     <textarea
//                       className="form-control"
//                       placeholder="Enter tips one per line"
//                       value={tips}
//                       onChange={(e) => setTips(e.target.value)}
//                     />
//                   </div>

//                   {/* NHS Guidance */}
//                   <div className="col-12">
//                     <h6>Based on trusted NHS Guidance</h6>
//                     {nhsGuidance.map((item, index) => (
//                       <div key={index} className="row g-2 mb-2">
//                         <div className="col-5">
//                           <input
//                             type="text"
//                             className="form-control"
//                             placeholder="Link text"
//                             value={item.text}
//                             onChange={(e) => updateNhsGuidance(index, "text", e.target.value)}
//                           />
//                         </div>
//                         <div className="col-5">
//                           <input
//                             type="url"
//                             className="form-control"
//                             placeholder="https://example.com"
//                             value={item.url}
//                             onChange={(e) => updateNhsGuidance(index, "url", e.target.value)}
//                           />
//                         </div>
//                         <div className="col-2">
//                           {nhsGuidance.length > 1 && (
//                             <button
//                               type="button"
//                               className="btn btn-outline-danger w-100"
//                               onClick={() => removeNhsGuidance(index)}
//                             >
//                               Remove
//                             </button>
//                           )}
//                         </div>
//                       </div>
//                     ))}
//                     <button
//                       type="button"
//                       className="btn btn-outline-primary btn-sm mt-2"
//                       onClick={addNhsGuidance}
//                     >
//                       + Add More
//                     </button>
//                     <small className="text-muted d-block mt-1">
//                       Add text and corresponding URL for NHS guidance links
//                     </small>
//                   </div>

//                   <div className="col-6">
//                     <h6>Total Marks</h6>
//                     <input
//                       type="number"
//                       className="form-control"
//                       value={marks}
//                       min="0"
//                       onChange={(e) => {
//                         const value = Number(e.target.value);
//                         if (value >= 0) setMarks(value);
//                       }}
//                     />
//                   </div>
//                   <div className="col-6">
//                     <h6>Total Time (minutes)</h6>
//                     <input
//                       type="number"
//                       className="form-control"
//                       value={totalTime}
//                       min="1"
//                       onChange={(e) => {
//                         const value = Number(e.target.value);
//                         if (value >= 1) setTotalTime(value);
//                       }}
//                     />
//                   </div>
//                 </div>

//                 {/* Questions */}
//                 {questions.map((q, idx) => (
//                   <div key={idx} className="border rounded p-3 mb-3">
//                     <h6>Question {idx + 1}</h6>
//                     <input
//                       type="text"
//                       className={`form-control mb-2 ${questionErrors[idx]?.question ? 'is-invalid' : ''}`}
//                       value={q.question}
//                       onChange={(e) => handleQuestionChange(idx, "question", e.target.value)}
//                     />
//                     {questionErrors[idx]?.question && (
//                       <small className="text-danger">{questionErrors[idx].question}</small>
//                     )}

//                     <div className="row g-2">
//                       {["a", "b", "c", "d"].map((opt) => (
//                         <div key={opt} className="col-12 col-md-6">
//                           <input
//                             type="text"
//                             className={`form-control ${questionErrors[idx]?.options?.[opt] ? 'is-invalid' : ''}`}
//                             value={q.options[opt]}
//                             placeholder={`Option ${opt.toUpperCase()}`}
//                             onChange={(e) => handleOptionChange(idx, opt, e.target.value)}
//                           />
//                           {questionErrors[idx]?.options?.[opt] && (
//                             <small className="text-danger">{questionErrors[idx].options[opt]}</small>
//                           )}
//                         </div>
//                       ))}
//                     </div>

//                     <select
//                       className={`form-select mt-2 ${questionErrors[idx]?.correct_answer ? 'is-invalid' : ''}`}
//                       value={q.correct_answer}
//                       onChange={(e) => handleQuestionChange(idx, "correct_answer", e.target.value)}
//                     >
//                       <option value="">Select Correct Answer</option>
//                       <option value="a">Option A</option>
//                       <option value="b">Option B</option>
//                       <option value="c">Option C</option>
//                       <option value="d">Option D</option>
//                     </select>
//                     {questionErrors[idx]?.correct_answer && (
//                       <small className="text-danger">{questionErrors[idx].correct_answer}</small>
//                     )}

//                     <textarea
//                       className="form-control mt-2"
//                       placeholder="Explanation (optional)"
//                       value={q.explanation}
//                       onChange={(e) => handleQuestionChange(idx, "explanation", e.target.value)}
//                     />
//                   </div>
//                 ))}
                
//                 {errors.questions && (
//                   <small className="text-danger d-block mb-2">
//                     {errors.questions}
//                   </small>
//                 )}

//                 <button 
//                   type="button" 
//                   className="btn btn-outline-primary mb-3" 
//                   onClick={addQuestion}
//                 >
//                   + Add Another Question
//                 </button>

//                 <div className="text-center">
//                   <button type="submit" className="btn btn-success px-4">
//                     Update Quiz
//                   </button>
//                 </div>
//               </form>
//             </div>
//           </div>
//         </div>
//       </section>
//     </div>
//   );
// };

// export default EditQuiz;


import React, { useEffect, useState, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { GetCategoryApi } from "../redux/actions/teams/members/GetCategoryAction";
import { GetQuizDetailApi } from "../redux/actions/teams/members/GetQuizDetailsActions";
import { UpdateQuiz } from "../redux/actions/teams/members/UpdateQuizAction";
import { PulseLoader } from "react-spinners";
import { getImageUrl } from "../helpers/utils";

const EditQuiz = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [quizName, setQuizName] = useState("");
  const [quizCategory, setQuizCategory] = useState("");
  const [description, setDescription] = useState("");
  const [tips, setTips] = useState("");
  const [nhsGuidance, setNhsGuidance] = useState([{ text: "", url: "" }]);
  const [marks, setMarks] = useState(50);
  const [totalTime, setTotalTime] = useState(60);
  const [statusss, setStatus] = useState(1);
  const [quizImage, setQuizImage] = useState(null);
  const [quizImageUrl, setQuizImageUrl] = useState("");
  const [quizImagePreview, setQuizImagePreview] = useState(null);

  const [questions, setQuestions] = useState([]);
  const [errors, setErrors] = useState({ 
    quizName: "", 
    quizCategory: "", 
    questions: "" 
  });
  
  const [questionErrors, setQuestionErrors] = useState([]);

  // Redux states
  const { response: categoryListResponse, loading: categoryListLoading } = useSelector(
    (state) => state.categoryList
  );
  const { response: quizDetailsResponse, loading: quizLoading, error: quizError } = useSelector(
    (state) => state.QuizDetails
  );
  const { loading: updateLoading, error: updateError } = useSelector((state) => state.updateQuiz);

  // Fetch categories
  const fetchCategories = useCallback(() => {
    dispatch(GetCategoryApi());
  }, [dispatch]);

  // Fetch quiz details
  useEffect(() => {
    if (id) {
      dispatch(GetQuizDetailApi(id));
    }
  }, [dispatch, id]);

  // NHS Guidance handlers
  const addNhsGuidance = () => {
    setNhsGuidance([...nhsGuidance, { text: "", url: "" }]);
  };

  const updateNhsGuidance = (index, field, value) => {
    const updated = [...nhsGuidance];
    updated[index][field] = value;
    setNhsGuidance(updated);
  };

  const removeNhsGuidance = (index) => {
    if (nhsGuidance.length > 1) {
      const updated = nhsGuidance.filter((_, i) => i !== index);
      setNhsGuidance(updated);
    }
  };

  // Load quiz details
  useEffect(() => {
    if (quizDetailsResponse?.status && quizDetailsResponse.data) {
      const d = quizDetailsResponse.data;
      setQuizName(d.quiz_name);
      setQuizCategory(d.quiz_category);
      setTips(d.tips ? d.tips.join("\n") : "");
      setDescription(d.description);
      setMarks(d.total_marks);
      setTotalTime(d.total_time);
      setStatus(d.statusss);
      
      // Load questions with proper structure
      const loadedQuestions = (d.questions || []).map(q => {
        const questionData = {
          _id: q._id,
          question: q.question,
          question_type: q.question_type || "mcq", // Default to mcq if not specified
          correct_answer: q.correct_answer || (q.question_type === "true_false" ? "a" : ""),
          explanation: q.explanation || "",
          status: q.status || 1
        };

        // Handle options based on question type
        if (q.question_type === "true_false") {
          questionData.true_false = q.true_false || { a: "True", b: "False" };
          // For backward compatibility, if options exist but question_type is true_false
          questionData.options = { a: "", b: "", c: "", d: "" };
        } else {
          questionData.options = q.options || { a: "", b: "", c: "", d: "" };
          questionData.true_false = { a: "True", b: "False" };
        }

        return questionData;
      });
      
      setQuestions(loadedQuestions);
      setQuestionErrors(Array(loadedQuestions.length).fill({}));

      if (d.nhs_guidance && Array.isArray(d.nhs_guidance)) {
        if (d.nhs_guidance.length > 0 && typeof d.nhs_guidance[0] === 'object') {
          setNhsGuidance(d.nhs_guidance.map(item => ({ 
            text: item.text, 
            url: item.url 
          })));
        } else {
          setNhsGuidance(d.nhs_guidance.map(text => ({ 
            text: text, 
            url: `https://www.nhs.uk/search/?q=${encodeURIComponent(text)}` 
          })));
        }
      } else {
        setNhsGuidance([{ text: "", url: "" }]);
      }

      if (d.quiz_image) {
        const imageValue = d.quiz_image;
        const previewUrl = getImageUrl(imageValue);
        setQuizImageUrl(/^https?:\/\//i.test(previewUrl) ? previewUrl : "");
        setQuizImagePreview(previewUrl);
      }
    }
  }, [quizDetailsResponse]);

  useEffect(() => {
    fetchCategories();
  }, [fetchCategories]);

  // Add new question
  const addQuestion = () => {
    setQuestions([
      ...questions,
      { 
        question: "", 
        question_type: "mcq",
        options: { a: "", b: "", c: "", d: "" },
        true_false: { a: "True", b: "False" },
        correct_answer: "", 
        explanation: "" 
      },
    ]);
    setQuestionErrors([...questionErrors, {}]);
  };

  // Handle question type change
  const handleQuestionTypeChange = (index, value) => {
    const updated = [...questions];
    updated[index].question_type = value;
    // Reset correct answer when changing type
    updated[index].correct_answer = "";
    setQuestions(updated);
    
    // Clear errors
    const updatedErrors = [...questionErrors];
    delete updatedErrors[index]?.correct_answer;
    if (value === "mcq") {
      delete updatedErrors[index]?.true_false;
    } else {
      delete updatedErrors[index]?.options;
    }
    setQuestionErrors(updatedErrors);
  };

  const handleQuestionChange = (index, field, value) => {
    const updated = [...questions];
    updated[index][field] = value;
    setQuestions(updated);

    // Clear error when field is filled
    if (value.trim() && field === "question") {
      const updatedErrors = [...questionErrors];
      delete updatedErrors[index]?.question;
      setQuestionErrors(updatedErrors);
    }
    if (value && field === "correct_answer") {
      const updatedErrors = [...questionErrors];
      delete updatedErrors[index]?.correct_answer;
      setQuestionErrors(updatedErrors);
    }
    if (value && field === "explanation") {
      const updatedErrors = [...questionErrors];
      delete updatedErrors[index]?.explanation;
      setQuestionErrors(updatedErrors);
    }
  };

  const handleOptionChange = (index, optKey, value) => {
    const updated = [...questions];
    updated[index].options[optKey] = value;
    setQuestions(updated);

    // Clear error when option is filled
    if (value.trim()) {
      const updatedErrors = [...questionErrors];
      if (updatedErrors[index]?.options?.[optKey]) {
        delete updatedErrors[index].options[optKey];
        setQuestionErrors(updatedErrors);
      }
    }
  };

  // Handle True/False text change
  const handleTrueFalseChange = (index, key, value) => {
    const updated = [...questions];
    updated[index].true_false[key] = value;
    setQuestions(updated);

    // Clear error when true/false text is filled
    if (value.trim()) {
      const updatedErrors = [...questionErrors];
      if (updatedErrors[index]?.true_false) {
        delete updatedErrors[index].true_false;
        setQuestionErrors(updatedErrors);
      }
    }
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setQuizImage(file);
      setQuizImageUrl("");
      setQuizImagePreview(URL.createObjectURL(file));
    }
  };

  // Validate individual question
  const validateQuestion = (question, index) => {
    const errors = {};
    
    if (!question.question.trim()) {
      errors.question = "Question is required";
    }
    
    if (!question.correct_answer) {
      errors.correct_answer = "Correct answer is required";
    }
    
    // Validate based on question type
    if (question.question_type === "mcq") {
      const optionErrors = {};
      let hasEmptyOption = false;
      
      Object.keys(question.options).forEach(opt => {
        if (!question.options[opt].trim()) {
          optionErrors[opt] = `Option ${opt.toUpperCase()} is required`;
          hasEmptyOption = true;
        }
      });
      
      if (hasEmptyOption) {
        errors.options = optionErrors;
      }
      
      // Validate correct answer is one of the options
      if (question.correct_answer && !["a", "b", "c", "d"].includes(question.correct_answer)) {
        errors.correct_answer = "Invalid correct answer for MCQ";
      }
    } else if (question.question_type === "true_false") {
      // For true/false questions, validate that both a and b have values
      if (!question.true_false?.a?.trim() || !question.true_false?.b?.trim()) {
        errors.true_false = "Both True and False text are required";
      }
      
      // Validate correct answer is a or b
      if (question.correct_answer && !["a", "b"].includes(question.correct_answer)) {
        errors.correct_answer = "Correct answer must be 'a' (True) or 'b' (False)";
      }
    }
    
    return errors;
  };

  const validateForm = () => {
    let valid = true;
    const newErrors = { quizName: "", quizCategory: "", questions: "" };
    const newQuestionErrors = [];

    if (!quizName.trim()) {
      newErrors.quizName = "Quiz name is required";
      valid = false;
    }
    if (!quizCategory) {
      newErrors.quizCategory = "Quiz category is required";
      valid = false;
    }

    if (!questions.length) {
      newErrors.questions = "At least one question is required";
      valid = false;
    } else {
      let hasQuestionError = false;
      
      questions.forEach((question, index) => {
        const questionError = validateQuestion(question, index);
        newQuestionErrors[index] = questionError;
        
        if (Object.keys(questionError).length > 0) {
          hasQuestionError = true;
        }
      });
      
      if (hasQuestionError) {
        newErrors.questions = "Please fix all question errors before submitting";
        valid = false;
      }
    }

    setErrors(newErrors);
    setQuestionErrors(newQuestionErrors);
    return valid;
  };

  // Prepare questions for API submission
  const prepareQuestionsForSubmission = () => {
    return questions.map(q => {
      const questionData = {
        question: q.question,
        question_type: q.question_type,
        correct_answer: q.correct_answer,
        explanation: q.explanation || "",
        status: q.status || 1
      };

      // Only include appropriate field based on question type
      if (q.question_type === "mcq") {
        questionData.options = q.options;
        // Remove true_false field for MCQ
        delete questionData.true_false;
      } else if (q.question_type === "true_false") {
        questionData.true_false = q.true_false;
        // Remove options field for True/False
        delete questionData.options;
      }

      // Keep _id for existing questions
      if (q._id) {
        questionData._id = q._id;
      }

      return questionData;
    });
  };

  // Submit
  const handleSubmit = (e) => {
    e.preventDefault();
    if (!validateForm()) return;

    const formData = new FormData();
    formData.append("quiz_category", quizCategory);
    formData.append("quiz_name", quizName);
    formData.append("description", description);
    formData.append("total_marks", marks);
    formData.append("total_questions", questions.length);
    formData.append("total_time", totalTime);
    formData.append("statusss", statusss);
    
    // Prepare questions
    const preparedQuestions = prepareQuestionsForSubmission();
    formData.append("questions", JSON.stringify(preparedQuestions));
    
    // Filter out empty NHS guidance entries
    const validNhsGuidance = nhsGuidance.filter(item => 
      item.text.trim() !== "" && item.url.trim() !== ""
    );
    formData.append("nhs_guidance", JSON.stringify(validNhsGuidance));
    
    const tipsArray = tips.split("\n").filter((t) => t.trim() !== "");
    formData.append("tips", JSON.stringify(tipsArray));

    if (quizImage) {
      formData.append("quiz_image", quizImage);
    } else if (quizImageUrl.trim()) {
      formData.append("quiz_image_url", quizImageUrl.trim());
    }

    dispatch(UpdateQuiz(id, formData))
      .then(() => navigate("/dashboard/quiz-management"))
      .catch((err) => console.error("Failed to update quiz:", err));
  };

  // Render question form based on type
  const renderQuestionForm = (q, idx) => {
    const isMCQ = q.question_type === "mcq";
    
    return (
      <div key={idx} className="border rounded p-3 mb-3">
        <div className="d-flex justify-content-between align-items-center mb-2">
          <h6 className="mb-0">Question {idx + 1}</h6>
          <div>
            <select
              className="form-select form-select-sm"
              value={q.question_type}
              onChange={(e) => handleQuestionTypeChange(idx, e.target.value)}
              style={{ width: "120px" }}
            >
              <option value="mcq">MCQ</option>
              <option value="true_false">True/False</option>
            </select>
          </div>
        </div>

        <input
          type="text"
          className={`form-control mb-2 ${questionErrors[idx]?.question ? 'is-invalid' : ''}`}
          value={q.question}
          onChange={(e) => handleQuestionChange(idx, "question", e.target.value)}
        />
        {questionErrors[idx]?.question && (
          <small className="text-danger">{questionErrors[idx].question}</small>
        )}

        {/* Options based on question type */}
        {isMCQ ? (
          <>
            <div className="row g-2">
              {["a", "b", "c", "d"].map((opt) => (
                <div key={opt} className="col-12 col-md-6">
                  <input
                    type="text"
                    className={`form-control ${questionErrors[idx]?.options?.[opt] ? 'is-invalid' : ''}`}
                    value={q.options[opt]}
                    placeholder={`Option ${opt.toUpperCase()}`}
                    onChange={(e) => handleOptionChange(idx, opt, e.target.value)}
                  />
                  {questionErrors[idx]?.options?.[opt] && (
                    <small className="text-danger">{questionErrors[idx].options[opt]}</small>
                  )}
                </div>
              ))}
            </div>

            <select
              className={`form-select mt-2 ${questionErrors[idx]?.correct_answer ? 'is-invalid' : ''}`}
              value={q.correct_answer}
              onChange={(e) => handleQuestionChange(idx, "correct_answer", e.target.value)}
            >
              <option value="">Select Correct Answer</option>
              <option value="a">Option A ({q.options.a || "A"})</option>
              <option value="b">Option B ({q.options.b || "B"})</option>
              <option value="c">Option C ({q.options.c || "C"})</option>
              <option value="d">Option D ({q.options.d || "D"})</option>
            </select>
          </>
        ) : (
          <>
            <div className="row g-2">
              <div className="col-6">
                <input
                  type="text"
                  className={`form-control ${questionErrors[idx]?.true_false ? 'is-invalid' : ''}`}
                  placeholder="True text"
                  value={q.true_false.a}
                  onChange={(e) => handleTrueFalseChange(idx, "a", e.target.value)}
                />
              </div>
              <div className="col-6">
                <input
                  type="text"
                  className={`form-control ${questionErrors[idx]?.true_false ? 'is-invalid' : ''}`}
                  placeholder="False text"
                  value={q.true_false.b}
                  onChange={(e) => handleTrueFalseChange(idx, "b", e.target.value)}
                />
              </div>
            </div>
            {questionErrors[idx]?.true_false && (
              <small className="text-danger">{questionErrors[idx].true_false}</small>
            )}

            <select
              className={`form-select mt-2 ${questionErrors[idx]?.correct_answer ? 'is-invalid' : ''}`}
              value={q.correct_answer}
              onChange={(e) => handleQuestionChange(idx, "correct_answer", e.target.value)}
            >
              <option value="">Select Correct Answer</option>
              <option value="a">{q.true_false.a || "True"}</option>
              <option value="b">{q.true_false.b || "False"}</option>
            </select>
          </>
        )}

        {questionErrors[idx]?.correct_answer && (
          <small className="text-danger">{questionErrors[idx].correct_answer}</small>
        )}

        <textarea
          className="form-control mt-2"
          placeholder="Explanation (optional)"
          value={q.explanation}
          onChange={(e) => handleQuestionChange(idx, "explanation", e.target.value)}
        />
      </div>
    );
  };

  if (quizLoading) return <div className="text-center p-5">Loading quiz...</div>;
  if (quizError) return <div className="text-center p-5 text-danger">Error loading quiz</div>;

  return (
    <div className="content-wrapper" style={{ backgroundColor: "#f5f5f5" }}>
      <section className="main-section">
        <div className="container py-5">
          <div className="row justify-content-center">
            <div className="col-12 col-md-10 col-lg-8">
              <form onSubmit={handleSubmit} className="p-3 shadow rounded bg-white">
                <h3 className="text-center mb-3">Edit Quiz</h3>

                {updateLoading && (
                  <div className="text-center mb-3">
                    <PulseLoader color="#36d7b7" size={10} />
                  </div>
                )}
                {updateError && (
                  <div className="alert alert-danger mb-3">
                    {updateError.data || "Failed to update quiz"}
                  </div>
                )}

                {/* Status */}
                <div className="d-flex justify-content-end mb-3">
                  <label className="me-2">Status</label>
                  <input
                    type="checkbox"
                    checked={statusss === 1}
                    onChange={(e) => setStatus(e.target.checked ? 1 : 0)}
                  />
                </div>

                {/* Image */}
                <div className="col-12 mb-3">
                  <h6>Quiz Image</h6>
                  <input type="file" className="form-control" accept="image/*" onChange={handleImageChange} />
                  <input
                    type="url"
                    className="form-control mt-2"
                    placeholder="Or paste image URL"
                    value={quizImageUrl}
                    onChange={(e) => {
                      setQuizImageUrl(e.target.value);
                      setQuizImage(null);
                      setQuizImagePreview(e.target.value);
                    }}
                  />
                  {quizImagePreview && (
                    <div className="mt-2 text-center">
                      <img src={quizImagePreview} alt="Preview" style={{ maxWidth: "150px", borderRadius: "6px" }} />
                    </div>
                  )}
                </div>

                {/* Info */}
                <div className="row g-3 mb-3">
                  <div className="col-12 col-md-6">
                    <h6>Quiz Name</h6>
                    <input 
                      type="text" 
                      className="form-control" 
                      value={quizName} 
                      onChange={(e) => setQuizName(e.target.value)} 
                    />
                    {errors.quizName && <small className="text-danger">{errors.quizName}</small>}
                  </div>
                  <div className="col-12 col-md-6">
                    <h6>Quiz Category</h6>
                    <select 
                      className="form-select" 
                      value={quizCategory} 
                      onChange={(e) => setQuizCategory(e.target.value)}
                    >
                      <option value="">Select Category</option>
                      {categoryListResponse?.data?.map((c) => (
                        <option key={c._id} value={c._id}>
                          {c.name}
                        </option>
                      ))}
                    </select>
                    {errors.quizCategory && <small className="text-danger">{errors.quizCategory}</small>}
                  </div>
                  <div className="col-12">
                    <h6>Description</h6>
                    <textarea 
                      className="form-control" 
                      value={description} 
                      onChange={(e) => setDescription(e.target.value)} 
                    />
                  </div>
                  <div className="col-12">
                    <h6>Tips & Guidelines</h6>
                    <textarea
                      className="form-control"
                      placeholder="Enter tips one per line"
                      value={tips}
                      onChange={(e) => setTips(e.target.value)}
                    />
                  </div>

                  {/* NHS Guidance */}
                  <div className="col-12">
                    <h6>Based on trusted NHS Guidance</h6>
                    {nhsGuidance.map((item, index) => (
                      <div key={index} className="row g-2 mb-2">
                        <div className="col-5">
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Link text"
                            value={item.text}
                            onChange={(e) => updateNhsGuidance(index, "text", e.target.value)}
                          />
                        </div>
                        <div className="col-5">
                          <input
                            type="url"
                            className="form-control"
                            placeholder="https://example.com"
                            value={item.url}
                            onChange={(e) => updateNhsGuidance(index, "url", e.target.value)}
                          />
                        </div>
                        <div className="col-2">
                          {nhsGuidance.length > 1 && (
                            <button
                              type="button"
                              className="btn btn-outline-danger w-100"
                              onClick={() => removeNhsGuidance(index)}
                            >
                              Remove
                            </button>
                          )}
                        </div>
                      </div>
                    ))}
                    <button
                      type="button"
                      className="btn btn-outline-primary btn-sm mt-2"
                      onClick={addNhsGuidance}
                    >
                      + Add More
                    </button>
                    <small className="text-muted d-block mt-1">
                      Add text and corresponding URL for NHS guidance links
                    </small>
                  </div>

                  <div className="col-6">
                    <h6>Total Marks</h6>
                    <input
                      type="number"
                      className="form-control"
                      value={marks}
                      min="0"
                      onChange={(e) => {
                        const value = Number(e.target.value);
                        if (value >= 0) setMarks(value);
                      }}
                    />
                  </div>
                  <div className="col-6">
                    <h6>Total Time (minutes)</h6>
                    <input
                      type="number"
                      className="form-control"
                      value={totalTime}
                      min="1"
                      onChange={(e) => {
                        const value = Number(e.target.value);
                        if (value >= 1) setTotalTime(value);
                      }}
                    />
                  </div>
                </div>

                {/* Questions */}
                {questions.map((q, idx) => renderQuestionForm(q, idx))}
                
                {errors.questions && (
                  <small className="text-danger d-block mb-2">
                    {errors.questions}
                  </small>
                )}

                <button 
                  type="button" 
                  className="btn btn-outline-primary mb-3" 
                  onClick={addQuestion}
                >
                  + Add Another Question
                </button>

                <div className="text-center">
                  <button type="submit" className="btn btn-success px-4">
                    Update Quiz
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default EditQuiz;
